export default "__VITE_ASSET__1451a007__"